
    /**
    * 【v1.4.0 】商家入驻保存 --【麦赖】
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiMerchantsSettle11080 {
  /**
   * 公司名称
   */
  companyName: string;
  /**
   * 联系姓名
   */
  name: string;
  /**
   * 联系电话
   */
  mobile: string;
  /**
   * 微信
   */
  wx: string;
  /**
   * qq
   */
  qq?: string;
  /**
   * 邮箱
   */
  email?: string;
  /**
   * 类目，数组
   */
  category: string;
  /**
   * 主营品牌
   */
  mainBrand: string;
  /**
   * 营业执照
   */
  businessLicense?: FileData;
  /**
   * 品牌授权书
   */
  brand?: FileData;
  /**
   * 其他资料
   */
  other?: FileData;
  /**
   * 遥望招商负责人
   */
  managerName: string;
}
    export class IResApiMerchantsSettle11080 {
  code?: number;
  message?: string;
  data?: {};
}
    const http: Serve<IReqApiMerchantsSettle11080, IResApiMerchantsSettle11080> = (data?) =>  request({
      method: 'POST',
      url: '/api/merchants/settle',
      data: data,
      headers:{'Content-Type': 'application/json;charset=UTF-8'}
    }) 
    export default http